import useUnsavedChangesGuard from 'src/hooks/useUnsavedChangesGuard';

/**
 * Renderless component that wires up `useUnsavedChangesGuard` from
 * inside a Formik render prop — hooks can't be called in the prop
 * callback directly, so this thin wrapper lets each form drop in a
 * `<FormGuard dirty={dirty} />` next to its form body.
 *
 * See `useUnsavedChangesGuard` for the scope and limitations.
 */
const FormGuard = ({ dirty }) => {
  useUnsavedChangesGuard(dirty);
  return null;
};

export default FormGuard;
